import { Controller } from "@hotwired/stimulus"

// Narrows the Status filter to the statuses used by the selected Task Types.
// Filters apply on Run rather than on change, so this runs in the browser
// instead of relying on a page reload.
export default class extends Controller {
  static targets = ["taskTypeSelect", "statusSelect"]
  static values = { statusMap: Object }

  connect() {
    // TomSelect initializes on its own connect; wait a tick so the control
    // exists before the first narrowing pass.
    requestAnimationFrame(() => this.taskTypesChanged())
  }

  taskTypesChanged() {
    if (!this.hasStatusSelectTarget) return

    const select = this.statusSelectTarget
    const ts = select.tomselect
    if (!ts) return

    const allowed = this.allowedStatuses()
    const selected = ts.getValue()
    const keep = Array.isArray(selected) ? selected : [selected].filter(Boolean)

    Object.entries(this.statusMapValue).forEach(([status, meta]) => {
      // A status the user already picked stays available, so switching task
      // types never silently drops part of their filter.
      if (allowed.includes(status) || keep.includes(status)) {
        if (!ts.options[status]) ts.addOption({ value: status, text: meta.label })
      } else if (ts.options[status]) {
        ts.removeOption(status)
      }
    })

    ts.refreshOptions(false)
  }

  // No task type chosen means every status is fair game.
  allowedStatuses() {
    const types = this.selectedTaskTypes()
    const all = Object.keys(this.statusMapValue)
    if (types.length === 0) return all

    return all.filter(status =>
      this.statusMapValue[status].types.some(type => types.includes(type))
    )
  }

  selectedTaskTypes() {
    if (!this.hasTaskTypeSelectTarget) return []

    const value = this.taskTypeSelectTarget.tomselect?.getValue() ??
      Array.from(this.taskTypeSelectTarget.selectedOptions).map(option => option.value)
    return Array.isArray(value) ? value.filter(Boolean) : [value].filter(Boolean)
  }
}
